import { Dispatch, SetStateAction, useState } from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import Img from '@/component/Img';
import OneLinkImg from '@/component/OneLinkImg';
import { Stage } from './const';
import Phone from './phone';
import Varify from './varify';


export default function Login(props: {
    setShowLogin: Dispatch<SetStateAction<boolean>>
}) {
  const { t } = useTranslation();
  const [stage, setStage] = useState(Stage.Start);
  const { setShowLogin } = props;
  const [countryCode, setCountryCode] = useState('1');
  const [mobileNumber, setMobileNumber] = useState();

  return (
    <div className={styles.loginWrapper}>
      <div className={styles.login}>
        <div className={styles.close} onClick={() => setShowLogin(false)} />
        {stage === Stage.Start &&
        <>
          <div className={styles.icon} />
          <div className={styles.title}>{t('DUET_WEB_SIGNIN_START_TITLE')}</div>
          <div className={styles.subTitle}>{t('DUET_WEB_SIGNIN_START_CONTENT')}</div>
          <div className={styles.button} onClick={() => setStage(Stage.Phone)}>
            <Img
              src="https://cdn.duetapp.net/v1/images/eyJpZCI6IllFNVY0U1hXWVdTTVZKQVBBNko3T1hLVkNUVk5TUSIsInciOjMyLCJoIjozNCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjMxMTIzMTU4MjU1ODM4Mjc3NTV9"
              alt=""
            />
            {t('DUET_WEB_SIGNIN_START_BUTTON')}
          </div>
          <div className={styles.text}>GET THE APP</div>
          <div className={styles.link}>
            <OneLinkImg
              src="https://cdn.duetapp.net/v1/images/eyJpZCI6IjNJNjdTQjJUVlBVTVU2NFhSTDNKSE4yRjRBVVpPQiIsInciOjMxNCwiaCI6OTYsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxMTY3NjgwODEzMTQ3NjUzMDgxNn0"
            />
            <OneLinkImg
              src="https://cdn.duetapp.net/v1/images/eyJpZCI6IkNOU0ZPNkRUQkVHUEhZSkNHRUtDVEZJV1AyMjVJVCIsInciOjMxNCwiaCI6OTYsImQiOjAsIm10IjoiaW1hZ2UvanBlZyIsImRoIjoxMTY5ODE2NzYwNTM3NzY5NzQ1OH0"
            />
          </div>
        </>}
        {stage === Stage.Phone &&
        <Phone
          setStage={setStage}
          setCountryCode={setCountryCode}
          countryCode={countryCode}
          mobileNumber={mobileNumber}
          setMobileNumber={setMobileNumber}
        />}
        {stage === Stage.Varify &&
        <Varify
          setStage={setStage}
          mobileNumber={mobileNumber}
          countryCode={countryCode}
        />}

      </div>
    </div>
  );
}
